import {
    SmartComposeInteraction,
    AcceptanceReason,
} from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';
SmartComposeInteraction;
export default function updateTelemetryForSuggestionOnSuggestionAccepted(
    suggestionTelemetry: SmartComposeInteraction,
    acceptedSuggestion: string,
    reason: AcceptanceReason
) {
    const now = new Date();
    suggestionTelemetry.suggestionAcceptanceTime = now;
    suggestionTelemetry.acceptedSuggestion = acceptedSuggestion;
    suggestionTelemetry.acceptanceReason = reason;
}
